import { connect } from 'react-redux';

import PlacePhotos from './PlacePhotos';

const mapStateToProps = (state) => {
    const {
        Global: { windowWidth },
    } = state;

    return { windowWidth };
};

export default connect(mapStateToProps, {})(PlacePhotos);

